
/**
 * For use with the ApparatusDetail Properties.
 * These constants corresponds to enum index of the corresponding SNMP property in 
 * the Generac.Common.Service.Activity.ResiSnmps in the API repo.
 * 
 * The number values MUST be kept in sync between these constants the C# enum file or the wrong SNMPs will be shown.
 */

/** SNMP 1.1.1.3.15 */
export const StandByHours_Hours_of_Protection = 32

/** SNMP 1.1.2.1.2 */
export const BatteryVoltage = 70

/** SNMP 1.1.2.1.3 */
export const RunHours_EngineHours = 71

/** SNMP  1.1.2.1.6 */
export const FuelLevel = 74

/** SNMP 1.1.2.1.13 */
export const BatteryVoltageAtECU = 81

